import React, { useEffect, useState } from "react";

// Import all sector images
import legalImg from "../../Assets/img/legal-system 1.svg";
import techImg from "../../Assets/img/computer-science 1.svg";
import recruitmentImg from "../../Assets/img/human-resources (2) 1.svg";
import engineeringRedImg from "../../Assets/img/engineering 1.svg";
import engineeringGreenImg from "../../Assets/img/healthcare (2) 1.svg";
import financialImg from "../../Assets/img/growth 1.svg";
import hotelsImg from "../../Assets/img/Group 43082.svg";
import manufacturingBlueGrayImg from "../../Assets/img/industrial 1.svg";
import manufacturingTealImg from "../../Assets/img/travel-and-tourism (2) 1.svg";
import accountingImg from "../../Assets/img/accounting (1) 1.svg";

const sectors = [
  { name: "Technology", color: "#7C4DFF", img: techImg },
  { name: "Engineering", color: "#E53935", img: engineeringRedImg },
  { name: "Financial Services", color: "#FFD700", img: financialImg },
  { name: "Accounting", color: "#81D4FA", img: accountingImg },
  { name: "HealthCare", color: "#66BB6A", img: engineeringGreenImg },
];

const BusinessSectors = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 576); // bootstrap "sm"
    };
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  return (
    <section className="main-icon container Apply-padding">
      <div className="">
        <h2 className="text-center font-weight-600" style={{ fontSize: "2rem" }}>
          Business Sectors We Support
        </h2>
        <p className="text-center fs-6 mx-auto mb-4" style={{ maxWidth: "700px" }}>
          Supporting businesses across various sectors and regions, we offer
          scalable recruitment strategies tailored to the unique challenges of each industry we serve.
        </p>

        <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 g-4 justify-content-center">
          {sectors.map((sector, index) => {
            // Force normal layout on mobile OR first 5 items
            const normalLayout = isMobile || index < 5;

            return (
              <div
                key={index}
                className="col d-flex flex-column align-items-center position-relative"
              >
                {normalLayout ? (
                  // 🔹 Normal Layout
                  <>
                    <span className="mt-2 text-center text-xs" style={{ height: "50px" }}>{sector.name}</span>
                    <div className="dot" style={{ backgroundColor: sector.color }}></div>
                    <div className="vertical-line"></div>
                    <div className="white-dot" style={{ backgroundColor: "#fff" }}></div>
                    <div className="sector-box" style={{ backgroundColor: sector.color }}>
                      <img
                        src={sector.img}
                        className="img-fluid"
                        width="65"
                        height="65"
                        alt={sector.name}
                      />
                    </div>
                  </>
                ) : (
                  // 🔹 Inverted Layout
                  <>
                    <div
                      className="sector-box"
                      style={{ backgroundColor: sector.color, marginBottom: "7px" }}
                    >
                      <img
                        src={sector.img}
                        className="img-fluid"
                        width="65"
                        height="65"
                        alt={sector.name}
                      />
                    </div>
                    <div className="white-dot" style={{ backgroundColor: "#fff" }}></div>
                    <div className="vertical-line"></div>
                    <div className="dot" style={{ backgroundColor: sector.color }}></div>
                    <span className="mt-2 text-center text-xs">{sector.name}</span>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BusinessSectors;
